import React, { useEffect, useState } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import sidelogo from "../../assets/sidelogogreen.png";
import sidelogo2 from "../../assets/sidelogogreen.png";
import { useSelector } from "react-redux";
import Footer from "./Footer";

const SideNavNew = ({ children }) => {
  const [show, setShow] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const currentPlan = useSelector((state) => state.PlanReducer.currentplan);
  const learnerData = useSelector((state) => state.UserReducer.user);

  const showNavbar = () => {
    setShow(true);
    const toggle = document.getElementById("header-toggle");
    // const toggle2 = document.getElementById("header-toggle2");
    const opentoggle = document.getElementById("open-toggel"),
      nav = document.getElementById("nav-bar"),
      bodypd = document.getElementById("body-pd"),
      headerpd = document.getElementById("header");

    // Validate that all variables exist
    // show navbar
    nav.classList.add("show_nav");
    // change icon
    toggle.classList.add("bx-x");
    // toggle2.classList.add("bx-x");
    opentoggle.classList.add("open");
    // add padding to body
    bodypd.classList.add("body-pd");
    // add padding to header
    headerpd.classList.add("body-pd");
  };

  const hideNavbar = () => {
    setShow(false);
    const toggle = document.getElementById("header-toggle");
    // const toggle2 = document.getElementById("header-toggle2");
    const opentoggle = document.getElementById("open-toggel"),
      nav = document.getElementById("nav-bar"),
      bodypd = document.getElementById("body-pd"),
      headerpd = document.getElementById("header");

    // Validate that all variables exist
    // show navbar
    nav.classList.remove("show_nav");
    // change icon

    toggle.classList.remove("bx-x");
    // toggle2.classList.remove("bx-x");
    opentoggle.classList.remove("open");
    // add padding to body
    bodypd.classList.remove("body-pd");
    // add padding to header
    headerpd.classList.remove("body-pd");
  };

  useEffect(() => {
    const bodypd = document.getElementById("body-pd");
    const headerpd = document.getElementById("header");
    const nav = document.getElementById("nav-bar");
    if (window.innerWidth < 992) {
      if (bodypd) {
        bodypd.classList.remove("body-pd");
      }
      if (headerpd) {
        headerpd.classList.remove("body-pd");
      }
      if (nav) {
        nav.classList.remove("show_nav");
      }
    }
  }, []);

  /*===== LINK ACTIVE  =====*/
  const linkColor = document.querySelectorAll(".nav__link");

  function colorLink() {
    if (linkColor) {
      linkColor.forEach((l) => l.classList.remove("active_nav"));
      this.classList.add("active_nav");
    }
  }

  linkColor.forEach((l) => l.addEventListener("click", colorLink));

  const logout = () => {
    localStorage.clear();
    history.push("/");
    localStorage.clear();
    localStorage.setItem("IS_LOGOUT", true);
  };

  return (
    <div className="clapingo_sidebar_main pt-4">
      <div className="clapingo_sidebar " id="body-pd">
        <header className="header " id="header">
          <div className="mobileview">
            <img src={sidelogo2} alt="logo" />
          </div>

          <div
            className="header__toggle"
            id="open-toggel"
            onClick={show ? hideNavbar : showNavbar}
          >
            <i className="bx bx-menu" id="header-toggle"></i>
          </div>
        </header>
        {/* <div className="header_content d-md-flex">
          <div
            className="content__toggle mt-3  mr-5 my-auto"
            id="open-toggel"
            onClick={show ? hideNavbar : showNavbar}
          >
            <i className="bx bx-menu" id="header-toggle2"></i>
          </div>
        </div> */}
        <div className="l-navbar " id="nav-bar">
          <nav className="nav">
            <div className="navside">
              <div>
                <div 
                className={`nav__logo ${!show?"center-img":"center_link"}`}
                onClick={show ? hideNavbar : showNavbar}

                >
                  <img
                    src={sidelogo2}
                    style={{ width: "1.9rem" }}
                    className={`nav__logo-icon ${!show?"center-img":""}`}
                    alt="logo"
                  />
         
                 {show?<span className="nav__logo-name">Clapingo</span>:""}
                </div>

                <div className="nav__list">
                  <Link
                    to="/courses"
                    id="navhome"
                    className={`nav__link  ${
                      location.pathname == "/courses" ? "active_nav" : ""
                    }`}
                    onClick={window.innerWidth < 992 ? () => hideNavbar() : ""}
                  >
                    <div
                      className={` ${
                        !show ? "d-flex flex-column center-icons" : "center_link"
                      }`}
                    >
                      <i className="fas fa-home nav__icon mx-auto"></i>
                      <span className={`${!show ? "nav__name" : "ml-3"}`}>
                        Home
                      </span>
                    </div>
                  </Link>


                   

                 


                  {/* <Link
                    id="navsubscription"
                    to="/courses"
                    className={`nav__link  ${
                      location.pathname == "/courses"
                        ? "active_nav"
                        : ""
                    }`}
                    onClick={window.innerWidth < 992 ? () => hideNavbar() : ""}
                  >
                    <div
                      className={` ${
                        !show ? "d-flex flex-column center-icons" : "center_link"
                      }`}
                    >
                      <i className="fas fa-cheese nav__icon mx-auto"></i>
                      <span className={`${!show ? "nav__name" : "ml-3"}`}>
                        Courses
                      </span>
                    </div>
                  </Link> */}

                
                

          
                </div>
              </div>
              <hr />
              <a href="/" className="nav__link" id="logoutid" onClick={logout}>
                <div
                      className={`text-danger ${
                        !show ? "d-flex flex-column center-icons" : "center_link"
                      }`}
                >
                  <i className="bx bx-log-out nav__icon mx-auto"></i>
                  <span className={`${!show ? "nav__name" : "ml-3"}`}>Log Out</span>
                </div>
              </a>
            </div>
          </nav>
        </div>

        <div className="child_content ">{children}</div>
        <Footer />
      </div>
    </div>
  );
};

export default SideNavNew;
